import { render, staticRenderFns } from "./IntegraRobosProcessos.vue?vue&type=template&id=21a71ba0"
import script from "./IntegraRobosProcessos.vue?vue&type=script&lang=js"
export * from "./IntegraRobosProcessos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports